import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import ContentPlayerModalContainer from '../Player/ContentPlayerModalContainer';

const IndependentLayout = () => {
  return (
    <Box sx={{ 
      p: 0, 
      m: 0,
      minHeight: '100vh',
      bgcolor: '#f5f5f5'
    }}>
      <Outlet />
      <ContentPlayerModalContainer />
    </Box>
  );
};

export default IndependentLayout;